var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5848_53595)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5848_53595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7417 10.3432C12.71 9.02187 13.1437 7.38367 12.956 5.75633C12.7683 4.12899 11.9731 2.63252 10.7294 1.56631C9.48579 0.500106 7.88543 -0.0572115 6.24851 0.00586168C4.6116 0.0689348 3.05886 0.747747 1.90095 1.90649C0.743029 3.06524 0.0653277 4.61846 0.00342583 6.25542C-0.058476 7.89238 0.499986 9.49234 1.56708 10.7352C2.63418 11.9781 4.13122 12.7723 5.7587 12.9588C7.38617 13.1453 9.02406 12.7104 10.3447 11.7412H10.3437C10.3737 11.7812 10.4057 11.8192 10.4417 11.8562L14.2917 15.7062C14.4792 15.8938 14.7336 15.9993 14.9988 15.9994C15.2641 15.9995 15.5185 15.8942 15.7062 15.7067C15.8938 15.5192 15.9993 15.2648 15.9994 14.9995C15.9995 14.7343 15.8942 14.4798 15.7067 14.2922L11.8567 10.4422C11.8209 10.406 11.7825 10.3726 11.7417 10.3422V10.3432ZM11.9997 6.49919C11.9997 7.22146 11.8574 7.93665 11.581 8.60394C11.3046 9.27123 10.8995 9.87755 10.3888 10.3883C9.87804 10.899 9.27173 11.3041 8.60444 11.5805C7.93715 11.8569 7.22195 11.9992 6.49968 11.9992C5.77741 11.9992 5.06221 11.8569 4.39492 11.5805C3.72763 11.3041 3.12131 10.899 2.61059 10.3883C2.09987 9.87755 1.69474 9.27123 1.41834 8.60394C1.14194 7.93665 0.999677 7.22146 0.999677 6.49919C0.999677 5.04049 1.57914 3.64155 2.61059 2.6101C3.64204 1.57865 5.04099 0.999185 6.49968 0.999185C7.95837 0.999185 9.35731 1.57865 10.3888 2.6101C11.4202 3.64155 11.9997 5.04049 11.9997 6.49919Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5848_53595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5848_53595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLight);
export default __webpack_public_path__ + "static/media/search_light.a14b9ba44d941966b078e27d5c2218d3.svg";
export { ForwardRef as ReactComponent };